import { useDispatch } from 'react-redux';
import { addProductToCompare } from '@client/product/redux/productsCompare/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useAddProductToCompareAction = (): typeof addProductToCompare => {
  const dispatch = useDispatch();

  return bindActionCreators(addProductToCompare, dispatch);
};
